import { useEffect, useState } from "react";
import { useShopifyScript } from "../hooks/useShopifyScript";

const DEFAULT_BUTTON_ID = "adhawk-shopify-camilyo-marketplace-add-to-cart";
const DEFAULT_BUTTON_SELECTOR = `button[id="${DEFAULT_BUTTON_ID}"]`;

export default function AddToCartButton({
  productHandle,
  universalRetailerId,
  label = "Add to Cart",
  visible = true,
  disabled = false,
  className = "",
  labelClass = "",
  onClick = () => {},
  scriptUrl,
}) {
  const [isReady, setIsReady] = useState(false);
  const { loadScript, isLoaded, isLoading } = useShopifyScript({
    autoRegister: true,
    buttonSelector: DEFAULT_BUTTON_SELECTOR,
    scriptUrl,
  });

  useEffect(() => {
    loadScript();
  }, [loadScript]);

  useEffect(() => {
    if (isLoaded) {
      setIsReady(true);
    }
  }, [isLoaded]);

  if (!visible) {
    return null;
  }

  const isDisabled =
    disabled || !productHandle || !universalRetailerId || isLoading || !isReady;

  return (
    <button
      id={DEFAULT_BUTTON_ID}
      type="button"
      data-product-handle={productHandle}
      data-universal-retailer-id={universalRetailerId}
      disabled={isDisabled}
      onClick={onClick}
      className={`${className} ${labelClass}`.trim()}>
      {label}
    </button>
  );
}
